import { ClipboardList, FileText, HardHat, KeyRound } from "lucide-react";

const STEPS = [
  { icon: ClipboardList, title: "Sopralluogo", desc: "Un tecnico verifica tetto, orientamento, ombreggiamenti e quadro elettrico." },
  { icon: FileText, title: "Proposta 48h", desc: "Entro 48 ore ricevi progetto, producibilità stimata e offerta chiara." },
  { icon: HardHat, title: "Installazione", desc: "Montaggio a regola d'arte da parte di installatori abilitati." },
  { icon: KeyRound, title: "Consegna", desc: "Collaudo, allaccio alla rete e attivazione del monitoraggio." },
];

export const Process = () => (
  <section id="processo" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <span className="eyebrow">Processo in 4 step</span>
      <h2 className="section-title mt-5 max-w-2xl">Dal sopralluogo alla consegna, senza pensieri.</h2>
      <ol className="mt-14 grid gap-px overflow-hidden rounded-3xl border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <li key={s.title} data-testid={`process-step-${i + 1}`} className="group bg-white p-8 transition-colors hover:bg-slate-50">
            <div className="flex items-center justify-between">
              <span className="font-display text-5xl font-semibold text-slate-200 transition-colors group-hover:text-emerald-500">0{i + 1}</span>
              <s.icon className="h-6 w-6 text-slate-900" />
            </div>
            <h3 className="mt-8 text-xl font-semibold text-slate-900">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
